import styled from 'styled-components';
import { scrollbar } from '../../../foundation/scrollbar/index.js';
import { LIST_GAP, SIDEBAR_PADDING, LIST_SCROLLBAR_OFFSET } from '../config.js';

var SidebarMenuBodyContainer = styled.div.withConfig({
  displayName: "SidebarMenuBodyContainer",
  componentId: "sc-124bx7e-0"
})(["flex:1 1 auto;display:flex;flex-direction:column;gap:", ";overflow:hidden auto;padding-left:", ";padding-right:calc(", " - ", ");margin-right:", ";", ""], LIST_GAP, SIDEBAR_PADDING, SIDEBAR_PADDING, LIST_SCROLLBAR_OFFSET, LIST_SCROLLBAR_OFFSET, scrollbar({
  trackSize: 4
}));

export { SidebarMenuBodyContainer };
